import React from "react";
import "./privacy.css";

export const Privacy: React.FC = () => {
    return (
        <div className="privacy-root">
            <h1>Here &amp; Now Privacy Policy</h1>
            <br/>
            <p>
                Here &amp; Now ("we," "us," or "our") respects your privacy. This Privacy
                Policy explains how we collect, use, and safeguard your information when
                you use our mobile application.
            </p>

            <h2>1. Information We Collect</h2>
            <p>We may collect the following types of information:</p>
            <ul>
                <li>
                    <strong>Personal Information:</strong> Name and email address
                </li>
                <li>
                    <strong>Location Information:</strong> Precise location (GPS) when you
                    enable location-based features
                </li>
                <li>
                    <strong>User Content:</strong> Photos, text, and submissions you
                    provide within the app
                </li>
                <li>
                    <strong>Usage Data:</strong> App performance data, feature usage, and
                    analytics
                </li>
            </ul>

            <h2>2. How We Use Your Information</h2>
            <p>Your information is used to:</p>
            <ul>
                <li>Provide and improve the app's features and services</li>
                <li>Deliver notifications, alerts, and updates</li>
                <li>Enable polls, surveys, feedback, and community engagement tools</li>
                <li>Analyze app usage to improve performance and reliability</li>
            </ul>

            <h2>3. Sharing of Information</h2>
            <p>We do not sell your personal information. We may share information:</p>
            <ul>
                <li>
                    With service providers (such as Firebase) who help operate the
                    application
                </li>
                <li>When required to comply with legal obligations</li>
                <li>
                    To protect the rights, safety, and security of users or the public
                </li>
            </ul>

            <h2>4. Tracking and Advertising</h2>
            <p>
                We do not track users across apps or websites owned by other companies.
                Optional sponsored content may appear within the app but is not linked
                to personal identifiers.
            </p>

            <h2>5. Data Retention</h2>
            <p>
                We retain information only as long as necessary to provide the app's
                services or comply with legal requirements.
            </p>

            <h2>6. Security</h2>
            <p>
                We use reasonable technical and administrative measures to protect your
                information from unauthorized access or disclosure.
            </p>

            <h2>7. Children's Privacy</h2>
            <p>
                The app is not intended for children under the age of 13. We do not
                knowingly collect personal information from children.
            </p>

            <h2>8. Your Choices</h2>
            <ul>
                <li>
                    You may choose not to provide certain information, though this may
                    limit app functionality.
                </li>
                <li>
                    You may disable location services and push notifications through your
                    device settings.
                </li>
            </ul>

            <h2>9. Changes to This Policy</h2>
            <p>
                We may update this Privacy Policy from time to time. Updates will be
                posted on this page.
            </p>

            <h2>10. Contact Us</h2>
            <p>
                If you have questions about this Privacy Policy or your data, please
                contact us:
            </p>
            <p>
                <strong>Email:</strong> herenow@vinformatix.com
            </p>
        </div>
    );
};
